import React from 'react';
import { Order as UIOrder } from '@shopee/chatbot-ui';
import { OrderProps } from '@shopee/chatbot-ui/lib/components/Order';
import { formatPrice } from '@/utils/tools';
import getHqUIOptimisationGroup, { HQ_UI_OPTIMISATION_GROUP } from '@/utils/experiment/getHqUIOptimisation';
import firstInitStore from '@/stores/firstInit';
import { ALL_BOT_TYPE } from '@/utils/constants';

interface PropsFromHistory {
  status_text?: string;
  total_price?: string;
}


const Order = (props: OrderProps & PropsFromHistory) => {
  const propsFromUnderScoreCase = {
    orderStatusText: props.status_text,
    totalPrice: formatPrice(props.total_price),
  };

  // 判断 chatbot 出的 order 样式是否需要 ui 优化
  // 首先要属于 buyer bot 其次 在实验组里
  // const useUIOptimisationHotQuestion = firstInitStore?.initStore?.botType === ALL_BOT_TYPE.INTENT_BASE_BOT && getHqUIOptimisationGroup() !== HQ_UI_OPTIMISATION_GROUP.CONTROL;
  return <UIOrder {...{ ...propsFromUnderScoreCase, ...props }} />;
};

export default Order;
